export default "__VITE_ASSET__CAvxYaLE__"